import React from 'react';
import { useTranslate } from 'hooks/useTranslate';
import { styled } from '@mui/system';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import ThumbDown from 'assets/icons/heroicons-outline_thumb-down.svg?react';
import ThumbUp from 'assets/icons/heroicons-outline_thumb-up.svg?react';
const Wrapper = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  flexDirection: 'column',
  marginBottom: 25,
  borderRadius: 15,
  padding: 20,
  backgroundColor: theme.palette.white.main
}));

const Title = styled(Typography)(() => ({
  fontWeight: 'bold',
  marginBottom: 20,
  fontSize: 18,
  textAlign: 'center'
}));

const Actions = styled('div')(() => ({
  display: 'flex',
  justifyContent: 'center',
  gap: 50
}));

const VoteComponent = () => {
  const t = useTranslate('Profession');
  const [voted, setVoted] = React.useState(false);

  const handleVote = React.useCallback(
    (vote) => {
      if (voted) return;
      import('services/analytics').then(({ default: A }) => A.event('VoteProfessionPage', { vote }));
      setVoted(true);
    },
    [voted]
  );

  return (
    <Wrapper>
      <Title variant={'h3'}>{t('VoteTitle')}</Title>
      <Actions>
        <IconButton onClick={() => handleVote('up')}>
          <ThumbUp />
        </IconButton>
        <IconButton onClick={() => handleVote('down')}>
          <ThumbDown />
        </IconButton>
      </Actions>
      {voted ? (
        <Typography variant={'h6'} align={'center'}>
          {t('VoteThanks')}
        </Typography>
      ) : null}
    </Wrapper>
  );
};

export default VoteComponent;
